import React, { useContext, useEffect } from 'react'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Divider from '@material-ui/core/Divider'
import { useTranslation } from 'react-i18next'
import CompanyBasicSettings from '../components/Company/CompanyBasicSettings'
import CompanyInfo from '../components/Company/CompanyInfo'
import { getWorkingPath, navigate } from 'hookrouter'
import withAccessControl from '../components/HOC/AccessControl'
import GlobalContext from '../lib/GlobalContext'
import UserTypes from '../components/Onboarding/UserTypes'
import Tooltip from '@material-ui/core/Tooltip'
import { ACL_COMPONENTS } from '../config'
import CompanyBusinessActivities from '../components/Company/CompanyBusinessActivities'
import CompanyReferences from '../components/Company/CompanyReferences'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  tabs: {
    fontSize: 14,
    height: '100%',
    width: '100%'
  },
  tab: {
    height: 64,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#525252'
  }
}))

/**
 * Company
 *
 * @returns {*}
 * @constructor
 */
const Company = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const {
    user,
    upgradeToPremiumOpen,
    setUpgradeToPremiumOpen,
    companyTabValue,
    setCompanyTabValue
  } = useContext(GlobalContext)

  /**
   * useEffect
   */
  useEffect(() => {
    switch (getWorkingPath()) {
      case '/company/references':
        setCompanyTabValue(3)
        break
      case '/company/activities':
        setCompanyTabValue(2)
        break
      case '/company/info':
        setCompanyTabValue(1)
        break
      case '/company/profile':
        setCompanyTabValue(0)
        break
      default:
        navigate('/company/profile')
        setCompanyTabValue(0)
        break
    }
  })

  /**
   * handleTabChange
   *
   * @param event
   * @param newValue
   */
  const handleTabChange = (event, newValue) => {
    setCompanyTabValue(newValue)
    switch (newValue) {
      case 3:
        if (user.getData().mode !== UserTypes.PRO) {
          setUpgradeToPremiumOpen(!upgradeToPremiumOpen)
        } else {
          navigate('/company/references')
        }
        break
      case 2:
        navigate('/company/activities')
        break
      case 1:
        if (user.getData().mode !== UserTypes.PRO) {
          setUpgradeToPremiumOpen(!upgradeToPremiumOpen)
        } else {
          navigate('/company/info')
        }
        break
      case 0:
      default:
        navigate('/company/profile')
        break
    }
  }

  /**
   * getContentRelatedToActiveTab
   */
  const getContentRelatedToActiveTab = () => {
    switch (companyTabValue) {
      case 3:
        return <CompanyReferences />
      case 2:
        return <CompanyBusinessActivities />
      case 1:
        return <CompanyInfo />
      case 0:
      default:
        return <CompanyBasicSettings />
    }
  }

  /**
   * return
   */
  return (
    <Paper className={classes.root}>
      <Tabs
        value={companyTabValue}
        className={classes.tabs}
        indicatorColor='primary'
        onChange={handleTabChange}
      >
        <Tab
          id='companyProfileTab'
          label={t('company.label.profile')}
          value={0}
          className={classes.tab}
        />
        {user.getData().mode !== UserTypes.PRO && (
          <Tooltip
            title={t('projects.free.route.premium.pro')}
            aria-label={t('projects.free.route.premium.pro')}
          >
            <Tab
              id='companyInfoTab'
              label={t('company.label.info')}
              value={1}
              className={classes.tab}
            />
          </Tooltip>
        )}
        {user.getData().mode === UserTypes.PRO && (
          <Tab
            id='companyInfoTab'
            label={t('company.label.info')}
            value={1}
            className={classes.tab}
          />
        )}
        <Tab
          id='companyBusinessActivities'
          label={t('company.label.businessActivities')}
          value={2}
          className={classes.tab}
        />
        {user.getData().mode !== UserTypes.PRO && (
          <Tooltip
            title={t('projects.free.route.premium.pro')}
            aria-label={t('projects.free.route.premium.pro')}
          >
            <Tab
              id='companyReferencesTab'
              label={t('company.label.references')}
              value={3}
              className={classes.tab}
            />
          </Tooltip>
        )}
        {user.getData().mode === UserTypes.PRO && (
          <Tab
            id='companyReferencesTab'
            label={t('company.label.references')}
            value={3}
            className={classes.tab}
          />
        )}
      </Tabs>
      <Divider />
      {getContentRelatedToActiveTab()}
    </Paper>
  )
}

export default withAccessControl(Company, ACL_COMPONENTS.COMPANY)
